export default {
  setPatient({ commit }, patient) {
    commit('updatePatient', patient)
  },

  setOrderDetails({ commit }, orderDetails) {
    commit('updateOrderDetails', orderDetails)
  },

  setMedicines({ commit }, selectedMedicines) {
    commit('updateSelectedMedicines', selectedMedicines)
  },

  setShippingFee({ commit }, shippingFee) {
    commit('updateShippingFee', shippingFee)
  },

  setShippingDate({ commit }, shippingDate) {
    commit('updateShippingDate', shippingDate)
  },

  setMinDate({ commit }, minDate) {
    commit('updateMinDate', minDate)
  },

  setMaxDate({ commit }, maxDate) {
    commit('updateMaxDate', maxDate)
  },

  setState({ commit }, state) {
    commit('updateState', state)
  },

  setCity({ commit }, city) {
    commit('updateCity', city)
  },



  setBranch({ commit }, branch) {
    commit('updateBranch', branch)
  },
  setBranchName({ commit }, branchName) {
    commit('updateBranchName', branchName)
  },
  setBranchAddress({ commit }, branchAddress) {
    commit('updateBranchAddress', branchAddress)
  },



  setSchedule({ commit }, schedule) {
    commit('updateSchedule', schedule)
  },

  setScheduleName({ commit }, scheduleName) {
    commit('updateScheduleName', scheduleName)
  },

  setProvider({ commit }, provider) {
    commit('updateProvider', provider)
  },

  setAddress({ commit }, address) {
    commit('updateAddress', address)
  },

  setPhone({ commit }, phone) {
    commit('updatePhone', phone)
  },

  setCellPhone({ commit }, cellPhone) {
    commit('updateCellPhone', cellPhone)
  },

  setObservations({ commit }, observations) {
    commit('updateObservations', observations)
  },

  setnameNomenclature({ commit }, nameNomenclature) {
    commit('updatenameNomenclature', nameNomenclature)
  },

  setnumberOne({ commit }, numberOne) {
    commit('updatenumberOne', numberOne)
  },

  setnumberTwo({ commit }, numberTwo) {
    commit('updatenumberTwo', numberTwo)
  },

  setnumberThree({ commit }, numberThree) {
    commit('updatenumberThree', numberThree)
  },
  setPropertyType({ commit }, propertyType) {
    commit('updatepropertyType', propertyType)
  },
  setComplementOne({ commit }, complementOne) {
    commit('updatecomplementOne', complementOne)
  },
  setBlockOrInside({ commit }, blockOrInside) {
    commit('updateblockOrInside', blockOrInside)
  },
  setComplementTwo({ commit }, complementTwo) {
    commit('updatecomplementTwo', complementTwo)
  }
}
